import { get, post } from '../shared/utils/FetchSSL.util';

export const getTagging = async (tokenSession?: string) => {
	try {
		const response = await get(`/user-interaction/taggings/users/by-user`, {
			token: true,
			isNewGateway: true,
			tokenSession,
		});
		return response;
	} catch (error) {
		throw error;
	}
};

export const postTagging = async (tag: object, tokenSession?: string) => {
	try {
		const response = await post(
			`/user-interaction/taggings/users/by-user`,
			tag,
			{
				token: true,
				isNewGateway: true,
				tokenSession,
			},
		);
		return response;
	} catch (error) {
		throw error;
	}
};
